import { HttpErrorResponse } from '@angular/common/http';
import { createSafeProps } from 'src/util/app-insights';

export enum SeverityLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4,
}

export abstract class Logger {
  public abstract error(
    error: Error | string,
    properties?: { [name: string]: string | undefined | null },
  ): void;
  public abstract info(
    message: string,
    properties?: { [name: string]: string | undefined | null },
  ): void;
  public abstract warning(
    message: string,
    properties?: { [name: string]: string | undefined | null },
  ): void;
}

export function transformError(err: unknown): {
  error: Error | string;
  properties?: { [name: string]: string };
} {
  const info: {
    error: Error | string;
    properties?: { [name: string]: string };
  } = { error: '' };
  if (err instanceof Error) {
    info.error = err;
  } else if (typeof err === 'string') {
    info.error = err;
  } else if (err instanceof HttpErrorResponse) {
    info.error = err.message;
    info.properties = createSafeProps({
      url: err.url,
      status: err.status.toString(),
      statusText: err.statusText,
    });
  } else if ('message' in (err as any)) {
    const error = err as any;
    info.error = error.message;
    for (const key in error) {
      if (key !== 'message') {
        info.properties = createSafeProps({ ...info.properties, [key]: error[key] });
      }
    }
  } else {
    info.error = JSON.stringify(err);
  }
  return info;
}
